import uuid from './uuid'

let socket = null
let connected = false
const cbHandle = {}

function doConnect() {
    socket = new WebSocket('ws://localhost:8080');
    //如果是https的话，端口是13529
    //socket = new WebSocket('wss://localhost:13529');
    // 打开Socket
    socket.onopen = function (event) {
        console.log('connect local success')
        connected = true
        // 监听消息
        socket.onmessage = function (event) {
            console.log('Client received a message', event);
            let response = JSON.parse(event.data)
            if (cbHandle['f' + response.requestID]) {
                cbHandle['f' + response.requestID](response)
            }
        };
        // 监听Socket的关闭
        socket.onclose = function (event) {
            connected = false
            console.log('Client notified socket has closed', event);
            setTimeout(() => {
                doConnect()
                // socket
            }, 1000)
        };

    };

    socket.onerror = (error) => {
        console.error(error)
    }
}

/***
 * 构造request对象
 */
const getRequestObject = (cmd, jobs, deviceId) => {
    let request = new Object();
    request.requestID = uuid.getUUID(8, 16);
    request.version = "1.0";
    request.cmd = cmd;
    if (jobs && jobs.length) {
        request.data = {
            jobs,
            deviceId
        }
    }
    return request;
}

// 获取打印机列表(getPrinters)
const findAllDevice = () => {
    let request = getRequestObject('findAllDevice')
    return sendCommand(request)
}

// 获取打印机配置(getPrinterConfig)
const getDeviceId = () => {
    let request = getRequestObject('getDeviceId')
    return sendCommand(request)
}

// 设置打印机配置(setPrinterConfig)
const status = () => {
    let request = getRequestObject('status')
    return sendCommand(request)
}

const sendCommand = (request) => {
    if (connected) {
        console.log('sendCommand', request)
        return new Promise((resolve, reject) => {
            socket.send(JSON.stringify(request))
            cbHandle['f' + request.requestID] = (response) => {
                if (response.error === 200) {
                    resolve(response.data)
                } else {
                    reject(response.message)
                }

                cbHandle['f' + request.requestID] = null
            }
        })
    } else {
        return Promise.reject({
            message: '标签打印组件未启动'
        })
    }
}

const sendPrintJobs = (jobs, deviceId) => {
    // deviceId需要解析
    let index = deviceId.indexOf(':::')
    if (index > -1) {
        deviceId = deviceId.slice(index + 3)
    }
    let request = getRequestObject('printLabel', jobs, deviceId)
    return sendCommand(request)
}

const copyProperties = (target, source) => {
    for (let key in source) {
        if (source.hasOwnProperty(key))
            target[key] = source[key]
    }
    console.log(target)
}

const getConnect = () => {
    return connected
}

export default {
    doConnect,
    getConnect,
    status,
    getDeviceId,
    findAllDevice,
    sendPrintJobs
}


// WEBPACK FOOTER //
// ./src/utils/local_printer.js